import ShiftBoardPage from './ShiftBoardPage';

export { default as ShiftBoardPrintPage } from './ShiftBoardPrintPage';
export { default as SubmissionsPage } from './SubmissionsPage';

export default ShiftBoardPage;
